module.exports = __webpack_public_path__ + "static/media/weekend.dacc0070.png";